import { FC } from 'react';
import packageJson from '../../../package.json';

export const Footer: FC = () => {
  return (
    <footer className="my-4 text-center">
      <p className="text-sm text-gray-500">Version: {packageJson.version}</p>
    </footer>
  );
};
